import { mutatorAction } from 'satcheljs';
import store from '../store/store';
import { InboxRule } from 'owa-inbox-rules-option';

export default mutatorAction('setCreatedRule', function setCreatedRule(createdRule: InboxRule) {
    store.createdRule = createdRule;
});
